import {
  ChevronLeft,
  ChevronRight
} from "./chunk-5VDSC7QK.mjs";

// src/link/src/link.tsx
import { cva } from "class-variance-authority";
import {
  forwardRef
} from "react";
import { jsx, jsxs } from "react/jsx-runtime";
var linkVariants = cva(
  "inline-block w-fit hover:underline hover:underline-offset-4 focus:outline-2 focus:outline-offset-4",
  {
    defaultVariants: { variant: "basic" },
    variants: {
      variant: {
        basic: ["text-interactive-secondary", "text-base-strong"],
        destructive: ["text-state-negative-text", "text-base-strong"],
        disabled: [
          "text-interactive-disabled",
          "hover:no-underline",
          "text-base-strong"
        ],
        inline: ["text-interactive-secondary"]
      }
    }
  }
);
var Inner = ({ children, startIcon, endIcon }) => /* @__PURE__ */ jsxs("span", { className: "flex gap-2", children: [
  startIcon ? /* @__PURE__ */ jsx(ChevronLeft, {}) : null,
  children,
  endIcon ? /* @__PURE__ */ jsx(ChevronRight, {}) : null
] });
var Link = forwardRef(
  ({
    variant,
    children,
    startIcon,
    endIcon,
    as,
    ...rest
  }, ref) => {
    if (variant === "disabled") {
      return (
        // https://www.scottohara.me/blog/2021/05/28/disabled-links.html
        // eslint-disable-next-line jsx-a11y/anchor-is-valid
        /* @__PURE__ */ jsx(
          "a",
          {
            "aria-disabled": true,
            className: linkVariants({ variant }),
            ref,
            role: "link",
            children: /* @__PURE__ */ jsx(Inner, { endIcon: Boolean(endIcon), startIcon: Boolean(startIcon), children })
          }
        )
      );
    }
    const Component = as ?? "a";
    return (
      // eslint-disable-next-line react/jsx-props-no-spreading
      /* @__PURE__ */ jsx(Component, { className: linkVariants({ variant }), ref, ...rest, children: /* @__PURE__ */ jsx(Inner, { endIcon: Boolean(endIcon), startIcon: Boolean(startIcon), children }) })
    );
  }
);
Link.displayName = "Link";

export {
  Link
};
